<template>
	<div style="height: 600px; overflow-y: auto; overflow-x: hidden">
		<Row :gutter="10" style="margin-bottom: 20px">

			<Col>
			<div style="margin-left: 30px;">
				<Select placeholder="排序类型" v-model="order_type" @on-change="mySearch">
					<Option value="desc" :key="1">正序 </Option>
					<Option value="asc" :key="2">倒序 </Option>
				</Select>
			</div>
			</Col>
		</Row>
		<Table border :columns="columns" :data="datas">
			<template slot-scope="{ row,index }" slot="min3">
				<div style="color:#63B3E6;cursor: pointer;">
					<div v-if="row.all_num !=0">
						<span>{{row.min3}}/{{(((row.min3)/row.all_num).toFixed(2))}}</span>
					</div>
					<div v-if="row.all_num ==0">
						<span>{{row.min3}}/0</span>
					</div>					
				</div>
			</template>
			<template slot-scope="{ row,index }" slot="min5">
				<div style="color:#63B3E6;cursor: pointer;">
					<div v-if="row.all_num !=0">
						<span>{{row.min5}}/{{(((row.min5)/row.all_num).toFixed(2))}}</span>
					</div>
					<div v-if="row.all_num ==0">
						<span>{{row.min5}}/0</span>
					</div>					
				</div>
			</template>
			<template slot-scope="{ row,index }" slot="min10">
				<div style="color:#63B3E6;cursor: pointer;">
					<div v-if="row.all_num !=0">
						<span>{{row.min10}}/{{(((row.min10)/row.all_num).toFixed(2))}}</span>
					</div>
					<div v-if="row.all_num ==0">
						<span>{{row.min10}}/0</span>
					</div>					
				</div>
			</template>
			<template slot-scope="{ row,index }" slot="min20">
				<div style="color:#63B3E6;cursor: pointer;">
					<div v-if="row.all_num !=0">
						<span>{{row.min20}}/{{(((row.min20)/row.all_num).toFixed(2))}}</span>
					</div>
					<div v-if="row.all_num ==0">
						<span>{{row.min20}}/0</span>
					</div>					
				</div>
			</template>
			<template slot-scope="{ row,index }" slot="twoplus">
				<div v-if="row.our_num !=0">
					<span>{{row.twoplus+row.three+row.four}}/{{(((row.twoplus+row.three+row.four)/row.our_num).toFixed(2))}}</span>
				</div>
				<div v-if="row.our_num ==0">
					<span>{{row.twoplus+row.three+row.four}}/0</span>
				</div>
			</template>
			<template slot-scope="{ row,index }" slot="threePlus">
				<div v-if="row.our_num !=0">
					<span>{{row.three+row.four}}/{{(((row.three+row.four)/row.our_num).toFixed(2))}}</span>
				</div>
				<div v-if="row.our_num ==0">
					<span>{{row.three+row.four}}/0</span>
				</div>
			</template>
			<template slot-scope="{ row,index }" slot="threePlusReal">
				<div v-if="row.our_num !=0">
					<span>{{row.three+row.four}}/{{(((row.three+row.four)/row.all_num).toFixed(2))}}</span>
				</div>
				<div v-if="row.our_num ==0">
					<span>{{row.three+row.four}}/0</span>
				</div>
			</template>
			<template slot-scope="{ row,index }" slot="zhuangku_rate">
				<div v-if="row.zhuangku_rate >0.2">
					<span style="color:#ffaa00;cursor: pointer;">{{row.zhuangku_rate}}</span>
				</div>
				<div v-else>
					<span>{{row.zhuangku_rate}}</span>
				</div>
			</template>
		</Table>
	</div>
</template>

<script>
	import {
		getAdidData
	} from "../../../api/advManage.js";
	import {
		mapGetters,
		mapActions
	} from "vuex";
  import {debounce} from "@/libs/util";
	export default {
		name: "adidData",
		components: {

		},
		props:['timePeriod','timePeriodDate','adid','city','advertiserId','src','account','operationUser','cid_type','adv_id'],
		data() {
			return {
				columns: [
					{
						"title": "城市",
						"key": "city",
						"align": 'center',
					},
					{
						"title": "所有城市量",
						"key": "all_num",
						"align": 'center',
					},
					{
						"title": "已回传数量",
						"key": "our_num",
						"align": 'center',
					},
					{
						"title": "已分发数量",
						"key": "distribute_num",
						"align": 'center',
					},
					{
						"title": "未分发数量",
						"key": "not_distribute_num",
						"align": 'center',
					},
					{
						"title": "撞库数量",
						"key": "zhuangku_num",
						"align": 'center',
					},
					{
						"title": "撞库率",
						"slot": "zhuangku_rate",
						"align": 'center',
					},
					{
						"title": "0星",
						"key": "zero",
						"align": 'center',
					},
					{
						"title": "1星",
						"key": "one",
						"align": 'center',
					},
					{
						"title": "2星",
						"key": "two",
						"align": 'center',
					},
					{
						"title": "2星+以上",
						"slot": "twoplus",
						"align": 'center',
					},
					{
						"title": "3星+以上",
						"slot": "threePlus",
						"align": 'center',
					},
					{
						"title": "实际3星+以上",
						"slot": "threePlusReal",
						"align": 'center',
					},
					{
						"title": "5万以下",
						"slot": "min3",
						"align": 'center',
					},
					{
						"title": "5~10万",
						"slot": "min5",
						"align": 'center',
					},
					{
						"title": "10~20万",
						"slot": "min10",
						"align": 'center',
					},
					{
						"title": "20万以上",
						"slot": "min20",
						"align": 'center',
					},
				],
				datas: [],
				order_type: 'desc'
			};
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		watch: {
			adid() {
				this.getList();
			},
			timePeriod() {
				this.getList();
			},
			cid_type(){
				this.getList();
			}
		},
		mounted() {
			this.getList();
		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			mySearch() {
				this.getList();
			},
			getList: debounce(async function() {
				let that = this;
				let data = {}
				data.token = this.token;
				data.adid = that.adid;
				data.timePeriod = that.timePeriod;
				data.timePeriodDate = that.timePeriodDate;
				data.city = that.city;
				data.cid_type = that.cid_type;
				data.src = that.src;
				data.advertiserId = that.advertiserId
				data.adv_id = that.adv_id;
				data.account = that.account;
				data.operationUser = that.operationUser;
				let res = await getAdidData(that, data);
				that.datas = res.data.list;
			}, 300),
		},
	};
</script>

<style lang="less" scoped>
/deep/ .ivu-table th {
  background: #277dd3;
  color: white;
}
/deep/ .ivu-table .table-blue-row td {
  color: #ff6699;
}
/deep/ .ivu-table .table-yellow-row td {
  color: #aaaa00;
}

/deep/ .ivu-table .table-black-row td {
  color: black;
}
	
</style>
